var _g;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLockIcon = function SvgLockIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 22,
    viewBox: "0 0 16 22",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H24V24H0z",
    transform: "translate(-4 -1.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M19.315 6.612c-.406-1.001-.98-1.896-1.704-2.658a7.903 7.903 0 00-2.522-1.802 7.53 7.53 0 00-6.18.002 7.886 7.886 0 00-2.522 1.8 8.4 8.4 0 00-1.704 2.658 8.626 8.626 0 00-.626 3.248v11.02c0 .9.696 1.632 1.554 1.632h12.771c.858 0 1.554-.732 1.55-1.632v-9.726l.004-.448V9.86a8.568 8.568 0 00-.621-3.248zM9.532 3.628h.005l.03-.012a5.821 5.821 0 012.43-.525c.842 0 1.662.179 2.433.52a6.457 6.457 0 012.016 1.44 6.84 6.84 0 011.38 2.156c.34.84.512 1.73.512 2.653v.694H5.658v-.696c0-.914.17-1.805.51-2.651A6.809 6.809 0 017.55 5.053a6.285 6.285 0 011.983-1.425zm8.813 8.522v8.728a.109.109 0 01-.005.033H5.663a.109.109 0 01-.005-.033V12.15h12.687zm-7.086 3.6v2.098a.743.743 0 001.486 0v-2.103c.394-.253.63-.68.63-1.153a1.376 1.376 0 00-2.75 0c.002.467.243.907.634 1.158z",
    transform: "translate(-4 -1.5)"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLockIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/lock-icon.3bb52c74.svg";
export { ForwardRef as ReactComponent };